import { getWallet, WalletKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { match } from "ts-pattern";
import {
  CoinbaseWalletIcon,
  MetamaskIcon,
  RabbyIcon,
  SafeIcon,
  WalletConnectIcon,
  WalletIcon,
} from "../../icons";

interface WalletDisplayProps {
  className?: string;
  walletKey: WalletKey;
}

export function WalletDisplay({
  className,
  walletKey,
}: WalletDisplayProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <Icon walletKey={walletKey} />

      <Label walletKey={walletKey} />
    </div>
  );
}

WalletDisplay.Icon = Icon;
WalletDisplay.Label = Label;

interface IconProps {
  className?: string;
  walletKey: WalletKey;
}

function Icon({ className, walletKey }: IconProps): JSX.Element {
  return match(walletKey)
    .with("metaMask", () => <MetamaskIcon className={className} />)
    .with("rabby", () => <RabbyIcon className={className} />)
    .with("coinbase", () => <CoinbaseWalletIcon className={className} />)
    .with("safe", () => <SafeIcon className={className} />)
    .with("walletConnect", () => <WalletConnectIcon className={className} />)
    .with("injected", () => <WalletIcon className={className} />)
    .exhaustive();
}

interface LabelProps {
  className?: string;
  walletKey: WalletKey;
}

function Label({ className, walletKey }: LabelProps): JSX.Element {
  const wallet = getWallet(walletKey);

  return <div className={cn("", className)}>{wallet.label}</div>;
}
